import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from '../app.component';
import {
    TranslateLoader,
    TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResponsiveModule } from 'ng2-responsive';
import { CustomFormsModule } from 'ng2-validation';
import { AppRoutingModule } from '../app-routing.module';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-modialog';
import { CardInputsCvcComponent } from './cvc/card-inputs.cvc.component';
import { CardInputsExpirationComponent } from './expiration/card-inputs.expiration.component';
import { CardInputsHolderNameComponent } from './holder-name/card-inputs.holder-name.component';
import { CardInputsNumberComponent } from './number/card-inputs.number.component';
import { WebpackTranslateLoader } from '../webpack-translate-loader';
import { CreditCardDirectivesModule } from 'ng-betalabs-creditcard';
import { TranslationConfiguratorService } from '../shared/services/translation-configurator.service';
import { LocaleProvider } from '../shared/services/locale.service';

@NgModule({
    declarations: [
        CardInputsCvcComponent,
        CardInputsExpirationComponent,
        CardInputsHolderNameComponent,
        CardInputsNumberComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        ReactiveFormsModule,
        AppRoutingModule,
        ResponsiveModule,
        CustomFormsModule,
        ModalModule.forRoot(),
        BootstrapModalModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-full-width',
            preventDuplicates: true
        }),
        CreditCardDirectivesModule
    ],
    providers: [
        LocaleProvider
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        TranslateModule,
        CardInputsCvcComponent,
        CardInputsExpirationComponent,
        CardInputsHolderNameComponent,
        CardInputsNumberComponent
    ]
})
export class CardInputsModule {

    constructor(
        public translate: TranslateService
    ) {
        translate.use(
            TranslationConfiguratorService.decideUseLanguage(this.translate.getBrowserLang())
        );
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/card-inputs/card-inputs.module.ts